(function() {
    'use strict';
 
    
// setup routing
a3_pilot_reports.config(routeConfig);

     /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name routeConfig
    * @description 
    *   Route configuration
    * @ngInject
    */  
function routeConfig($routeProvider) {
	$routeProvider
		.when('/', {
			controller:'CalendarCtrl',
			templateUrl:'./views/calendar.html'
		})
		.when('/login', {
			controller:'LoginCtrl',
			templateUrl:'./views/login.html'
		})
		.when('/flightinfo/:flightId', {
				controller: 'FlightInfoCtrl',
				templateUrl: 'views/flight-info.html',
                reloadOnSearch: false
		})
		.when('/selectedflightinfo/:flightId/:flightDate/:flightNo/:departure', {
            controller: 'SelectedFlightCtrl',
            templateUrl: 'views/SearchFlights/selected-flight-info.html',
            reloadOnSearch: false
        })
		.when('/report/:reportId', {
			controller:'ReportCtrl',
			templateUrl:'./views/report.html'
		})
		.when('/report/:reportId/:flightId', {
			controller:'ReportCtrl',
			templateUrl:'./views/report.html'
		})
		.when('/pdf/:reportId', {
			controller:'ReportCtrl',
			templateUrl:'./views/report.html'
		})
		.when('/pax/:flightId', {
			controller: 'PaxCtrl',
			templateUrl: 'views/pax.html'
		})
		.when('/addflight', {
			controller:'AddFlightCtrl',
			templateUrl:'./views/addflight.html'
		})
		.when('/reset', {
			controller:'ResetDeviceCtrl',
			templateUrl:'./views/reset.html'
		})
		.when('/messages/:flightId', {
				controller: 'MessageCtrl',
				templateUrl: 'views/messages.html'
		 })
		.when('/messages/', {
				controller: 'MessageCtrl',
				templateUrl: 'views/messages.html'
		 })
		.when('/debug', {
			controller:'DebugCtrl',
			templateUrl:'./views/debug.html'
		})
		.when('/rosterRequests', {
            controller: 'RequestsCtrl',
            templateUrl: 'views/RosterRequests/requests.html'
        })
		.when('/memos/:filter', {
			controller: 'MemosCtrl',
			templateUrl: 'views/Memos/memos.html'
		})
		.when('/memos', {
			controller: 'MemosCtrl',
			templateUrl: 'views/Memos/memos.html'
		})
        .when('/ticket', {
			controller: 'TicketCtrl',
			templateUrl: 'views/ticket.html'
		})
		.when('/bucket', {
            controller: 'BucketCtrl',
            templateUrl: 'views/Bucket/bucketCalendar.html'
        })
		.when('/bucketDay/:dutyId', {
            controller: 'BucketDayCtrl',
            templateUrl: 'views/Bucket/bucketDay.html'
        })
        .when('/leaverequest', {
            controller: 'LeaveRequestCtrl',
            templateUrl: 'views/LeaveRequest/leaveRequest.html'
        })
        .when('/groundDuty/:groundDutyId', {
            controller: 'GroundDutyCtrl',
            templateUrl: 'views/GroundDuty/groundDuty-info.html'
        })
		.when('/crewRoute/:dutyNo/:dutyDay', {
			controller: 'CrewRouteCtrl',
			templateUrl: 'views/CrewRoute/crew-route-info.html',
		})
		.when('/reportsHistory/:reportId/:flightId?/:reportType', {
			controller: 'ReportsHistoryCtrl',
			templateUrl: 'views/reportsHistory.html'
		})
		.when('/flightcourse/:courseId/:dutyNo/:dutyDay/:date',{
            controller: 'FlightCourseCtrl',
            templateUrl: 'views/Training/flightCourse.html'
         })
         .when('/flightcourse/:courseId/:dutyNo/:dutyDay/:date/:flightId',{
            controller: 'FlightCourseCtrl',
            templateUrl: 'views/Training/flightCourse.html'
         })
		 .when('/flightcourse/:courseId/:dutyNo/:dutyDay/:date/:flightId/:phaseId',{
            controller: 'FlightCourseCtrl',
            templateUrl: 'views/Training/flightCourse.html'
         })
		 .when('/groundcourse/:courseId/:dutyId/:date',{
            controller: 'GroundCourseCtrl',
            templateUrl: 'views/Training/groundCourse.html'
         })
		 .when('/groundcourse/:courseId/:dutyId/:date/:phaseId',{
            controller: 'GroundCourseCtrl',
            templateUrl: 'views/Training/groundCourse.html'
         })
		 .when('/groundHistory/:courseId/:dutyId/:date/:phaseId',{
            controller: 'ModuleHistoryCtrl',
			templateUrl: 'views/Training/moduleHistory.html'
         })
		//  .when('/flightHistory/:courseId/:dutyNo/:dutyDay/:date/:phaseId',{
        //     controller: 'ModuleHistoryCtrl',
		// 	templateUrl: 'views/Training/moduleHistory.html'
        //  })
		 .when('/flightHistory/:courseId/:dutyNo/:dutyDay/:date/:flightId/:phaseId',{
            controller: 'ModuleHistoryCtrl',
			templateUrl: 'views/Training/moduleHistory.html'
         })
		 .when('/flightHistory/:combinedId/:dutyNo/:dutyDay/:date', {
			controller: 'ModuleHistoryCtrl',
			templateUrl: 'views/Training/moduleHistory.html'
		})		
		.when('/safetyreport/flightcrewreport/:flightId',{
			controller: 'SafetyCtrl',
			templateUrl: 'views/Safety/flightCrewReport.html'
		})
		.when('/safetyreport/fatiguereport/:flightId',{
			controller: 'FatigueCtrl',
			templateUrl: 'views/Safety/fatigueReport.html'
		})
		.when('/traineecourse/:traineeCourseId/:dutyId/:date',{
			controller: 'TraineeCourseCtrl',
			templateUrl: 'views/TraineeCourse/trainee-course.tpl.html'
		}) 
		.when('/crewExpiries', {
			controller: 'CrewExpiriesCtrl',
			templateUrl: 'views/CrewExpiries/crewExpiries.html'
		})
		.otherwise({
			redirectTo:'/'
		})
 
 }
    
})();   